(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .factory('AiChat', AiChat);

    AiChat.$inject = ['$http'];

    function AiChat($http) {
        return {
            bootstrap: bootstrap,
            status: status
        };

        function bootstrap() {
            return $http.post('api/ai-chat/bootstrap').then(function(response) {
                return response.data;
            });
        }

        function status() {
            return $http.get('api/ai-chat/status').then(function(response) {
                return response.data;
            });
        }
    }
})();
